import { Link } from 'react-router';
import { ShieldOff } from 'lucide-react';
import { Botao } from '@/components/ui/button';

export function PaginaSemPermissao() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <ShieldOff className="text-silenciado-texto size-12" aria-hidden="true" />
      <h1 className="text-xl font-semibold">Acesso não autorizado</h1>
      <p className="text-silenciado-texto max-w-prose text-sm">
        Seu perfil não tem permissão para acessar esta área. Se você acredita que isso é um engano,
        procure a administração do sistema.
      </p>
      <Botao asChild>
        <Link to="/">Voltar ao início</Link>
      </Botao>
    </div>
  );
}
